const Arch = () =>{
 return(
    <img alt="arch"  className="md:w-[760px] mt-2" src="/presentationAssets/arch.png"/>
 )
}

export default Arch